import { ref, type Ref } from 'vue'
import useCanvas from '@lib/apps/canvas-builder/composables/useCanvas'
import type { AppFile } from '@lib/types/app'
import { FileTypeEnum } from '@openapi'

export type MultimediaSelectorApp = {
  id: string
  name: string
  displayName: string
  icon?: string
  entry?: string
}

export type MultimediaSelectorItem = {
  id: string
  name: string
  thumbnailUrl: string
  url: string
  type: 'image' | 'video'
  source: string // app id
}

// Store the loaded multimedia-selector apps as full AppFile objects
const multimediaSelectorApps: Ref<AppFile[]> = ref([])

export const useMultimediaSelectorApps = () => {
  const { listFiles } = useCanvas()

  const loadMultimediaSelectorApps = async (): Promise<AppFile[]> => {
    if (multimediaSelectorApps.value.length > 0) {
      return multimediaSelectorApps.value
    }

    const filesList = (await listFiles.value?.({
      filters: { type: [FileTypeEnum.APP] },
    })) as AppFile[]

    multimediaSelectorApps.value =
      filesList?.filter((app) => app.app_metadata?.provide?.includes('multimedia_selector')) ?? []

    return multimediaSelectorApps.value
  }

  return {
    multimediaSelectorApps,
    loadMultimediaSelectorApps,
  }
}
